import { render, staticRenderFns } from "./zimmerkontingente-widget.vue?vue&type=template&id=44675d72&scoped=true"
import script from "./zimmerkontingente-widget.vue?vue&type=script&lang=js"
export * from "./zimmerkontingente-widget.vue?vue&type=script&lang=js"
import style0 from "./zimmerkontingente-widget.vue?vue&type=style&index=0&id=44675d72&prod&lang=scss&scoped=true"
import style1 from "./zimmerkontingente-widget.vue?vue&type=style&index=1&id=44675d72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44675d72",
  null
  
)

export default component.exports